module.exports = __webpack_public_path__ + "static/media/plus.a12bab49.svg";